export function useContentOwnershipMedia (contentOwnership) {
  function getMedia (type) {
    if (contentOwnership[`_${type}Blob`]) {
      return contentOwnership[`_${type}Blob`];
    };
    const src = contentOwnership[`${type}Url`] || contentOwnership[`${type}Mp4Url`];
    return src && {
      title: '',
      src,
    };
  }
  function onFileUploadInput ({ id, src }) {
    if (id === 'image') {
      contentOwnership.imageUrl = src;
    }
    if (id === 'video') {
      contentOwnership.videoUrl = src;
    }
    if (id === 'gameplayVideoMp4Url ') {
      contentOwnership.gameplayVideoMp4Url = src;
    }
  }
  function onFileUploadClear ({ id }) {
    if (`_${id}Blob` in contentOwnership) {
      contentOwnership[`_${id}Blob`] = null;
    } else {
      const key = `${id}Url` in contentOwnership ? `${id}Url` : `${id}Mp4Url`;
      contentOwnership[key] = null;
    }
  }
  return {
    getMedia,
    onFileUploadInput,
    onFileUploadClear,
  };
}
